import { FC } from 'react';
import { SvgProps } from '../interfaces/Icon';

const ArrowUp: FC<SvgProps> = ({ size, className, color }) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.29289 0.292893C7.68342 -0.0976311 8.31658 -0.0976311 8.70711 0.292893L15.4571 7.04289C15.8476 7.43342 15.8476 8.06658 15.4571 8.45711C15.0666 8.84763 14.4334 8.84763 14.0429 8.45711L9 3.41421V16C9 16.5523 8.55228 17 8 17C7.44772 17 7 16.5523 7 16V3.41421L1.95711 8.45711C1.56658 8.84763 0.933417 8.84763 0.542893 8.45711C0.152369 8.06658 0.152369 7.43342 0.542893 7.04289L7.29289 0.292893Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default ArrowUp;
